import axios, { AxiosError } from "axios";
import { Constants, Environment, JsonUtil } from "../../../utils";
import { LoanStatusChangeEmail, PreviewedEmail } from "../../../domain/models";
import { LoanStatusChangeEmailMapper, PreviewedEmailMapper } from "./mappers";
import { LoanStatusChangeEmailsRepository } from "../../../domain/repositories";
import { LoanStatusChangeEmailEntity, PreviewedEmailEntity } from "./entities";
import { LocalStorageTokenRepository } from "..";

export default class RestLoanStatusChangeEmailsRepository implements LoanStatusChangeEmailsRepository {
  private static instance: RestLoanStatusChangeEmailsRepository;

  private constructor() { }

  static getInstance() {
    if (!this.instance) {
      this.instance = new RestLoanStatusChangeEmailsRepository();
    }
    return this.instance;
  }

  async getEmails(): Promise<[LoanStatusChangeEmail[]?, string?]> {
    try {
      const token = LocalStorageTokenRepository.getInstance().getToken();

      const response = await axios.get<LoanStatusChangeEmailEntity[]>(`${Environment.backendUrl}/admin/v1/loan_status_change_emails?t=${token}`);
      const emails = response.data.map(LoanStatusChangeEmailMapper.toModel);

      return [emails, undefined];
    } catch (error) {
      let mssg = Constants.GENERIC_ERROR_MSSG;
      if (error instanceof AxiosError) {
        mssg = JsonUtil.mssgFromError(error);
      }
      if (Environment.env === 'development') { console.log(error); }
      return [undefined, mssg];
    }
  }

  async getEmail(id: string): Promise<[LoanStatusChangeEmail?, string?]> {
    try {
      const token = LocalStorageTokenRepository.getInstance().getToken();

      const response = await axios.get<LoanStatusChangeEmailEntity>(`${Environment.backendUrl}/admin/v1/loan_status_change_emails/${id}?t=${token}`);
      const email = LoanStatusChangeEmailMapper.toModel(response.data);

      return [email, undefined];
    } catch (error) {
      let mssg = Constants.GENERIC_ERROR_MSSG;
      if (error instanceof AxiosError) {
        mssg = JsonUtil.mssgFromError(error);
      }
      if (Environment.env === 'development') { console.log(error); }
      return [undefined, mssg];
    }
  }

  async updateEmail(id: string, subject: string, body: string): Promise<[LoanStatusChangeEmail?, string?]> {
    try {
      const token = LocalStorageTokenRepository.getInstance().getToken();

      const response = await axios.put<LoanStatusChangeEmailEntity>(`${Environment.backendUrl}/admin/v1/loan_status_change_emails/${id}?t=${token}`, {
        subject,
        body
      });
      const email = LoanStatusChangeEmailMapper.toModel(response.data);

      return [email, undefined];
    } catch (error) {
      let mssg = Constants.GENERIC_ERROR_MSSG;
      if (error instanceof AxiosError) {
        mssg = JsonUtil.mssgFromError(error);
      }
      if (Environment.env === 'development') { console.log(error); }
      return [undefined, mssg];
    }
  }

  async previewEmail(id: string): Promise<[PreviewedEmail?, string?]> {
    try {
      const token = LocalStorageTokenRepository.getInstance().getToken();

      const response = await axios.get<PreviewedEmailEntity>(`${Environment.backendUrl}/admin/v1/loan_status_change_emails/${id}/preview?t=${token}`);
      const preview = PreviewedEmailMapper.toModel(response.data);

      return [preview, undefined];
    } catch (error) {
      let mssg = Constants.GENERIC_ERROR_MSSG;
      if (error instanceof AxiosError) {
        mssg = JsonUtil.mssgFromError(error);
      }
      if (Environment.env === 'development') { console.log(error); }
      return [undefined, mssg];
    }
  }
}